import { MessageDialogComponent } from './ui/atoms/dialogs/message-dialog/components/message-dialog.component';
import { NgModule, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { SpanishPaginatorIntl } from './shared/services/SpanishPaginatorIntl.service';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule, Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoginPageComponent } from './pages/authmanagement/page/login/loginPage.component';
import { AuthInterceptorService } from './pages/authmanagement/services/Auth-interceptor.service';
import { AuthGuard } from './pages/authmanagement/guards/auth.guard';
import { SentryHttpInterceptorService } from './shared/services/Sentry-interceptor.service';
import { ConfigurationsPageComponent } from './pages/dashboard-admin/page/configurationsPage.component';
import { MaterialModule } from '../material.module';
import { LoadingComponent } from './ui/atoms/loading/components/loading.component';
import { TooltipComponent } from './ui/atoms/tooltip/components/tooltip.component';
import { RouteMapComponent } from './map-features/sections/route-section/components/1-route-section/template/route-section/route-section.component';
import { RouteFilterComponent } from './map-features/sections/route-section/components/2-route-filter/organisms/route-filter/route-filter.component';
import { MapComponent } from './pages/maps/components/map/map.component';
import { PanelInternalLayersComponent } from './map-features/sections/locations-section/components/4-panel-layers/organisms/panel-internal-layers/panel-internal-layers.component';
import { LocationsMapComponent } from './map-features/sections/locations-section/components/1-locations-section/template/locations-section/locations-section.component';
import { CommonModule } from '@angular/common';
import { BrowserModule, DomSanitizer } from "@angular/platform-browser";
import { JwtHelperService, JwtModule, JWT_OPTIONS } from '@auth0/angular-jwt';
import { LogoutComponent } from './pages/authmanagement/components/logout/logout.component';
import { SignalRService } from './shared/services/Signal-R.service';
import { BasemapSelectorComponent } from './pages/maps/components/basemap-selector/basemap-selector.component';
import { PanelResumeRouteComponent } from './map-features/sections/route-section/components/3-panel-resume-route/organisms/panel-resume-route/panel-resume-route.component';
import { PanelDetailRouteStepsComponent } from './map-features/sections/route-section/components/3-panel-resume-route/molecules/panel-detail-routeSteps/panel-detail-routeSteps.component';
import { PanelGeofencesComponent } from './map-features/sections/geofences-section/components/2-panel-geofences/organisms/panel-geofences/panel-geofences.component';
import { PanelDetailGeofencesComponent } from './map-features/sections/geofences-section/components/3-panel-detail-geofences/organisms/panel-detail-geofences/panel-detail-geofences.component';
import { NavHeaderComponent } from './ui/organisms/header/components/nav-header.component';
import { TableauModule } from 'ngx-tableau'; 
import { ToastrModule } from 'ngx-toastr';
import { ConfirmDialogComponent } from './ui/atoms/dialogs/confirm-dialog/components/confirm-dialog.component';
import { ReportListComponent } from './map-features/ui/organisms/report-list/components/report-list/report-list.component';
import { UserPageComponent } from './pages/users/page/userPage/userPage.component';
import { UsersListComponent } from './pages/users/components/users-list/users-list.component';
import { UsersUpdateComponent } from './pages/users/components/users-update/users-update.component';
import { RecoveryPasswordDialogComponent } from './pages/authmanagement/dialog/recovery-password-dialog/recovery-password-dialog.component';
import { RecoveryPasswordPageComponent } from './pages/authmanagement/page/recovery-password/recovery-passwordPage.component';
import { SendRecoveryPasswordDialogComponent } from './pages/authmanagement/dialog/send-recovery-password-dialog/send-recovery-password-dialog.component';
import { EmailSendDialogComponent } from './pages/authmanagement/dialog/email-send-dialog/email-send-dialog.component';
import { AdminVinControlComponent } from './pages/users/components/admin-vin-control/admin-vin-control.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import {MatExpansionModule} from '@angular/material/expansion';
import { MatChipsModule } from '@angular/material/chips';
import { ErrorPageComponent } from './pages/error-page/page/error-page.component';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { NgChartsModule } from 'ng2-charts';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { MapHelperService } from 'src/services/map-helper.service';
import { FrecuencyZonesSectionComponent } from './map-features/sections/frecuency-zones-section/components/frecuency-zones-section/template/frecuency-zones-section/frecuency-zones-section.component';
import { FrecuencyIconsPipe } from './map-features/sections/frecuency-zones-section/pipes/frecuency-icons.pipe';
import { GeofencesMapComponent } from './map-features/sections/geofences-section/components/1-geofences-section/template/geofences-section/geofences-section.component';
import { BufferSelectorComponent } from './map-features/sections/geofences-section/components/4-panel-edit-geofences/molecules/buffer-selector/buffer-selector.component';
import { GeofencePolygonCreatorComponent } from './map-features/sections/geofences-section/components/4-panel-edit-geofences/molecules/geofence-polygon-creator/geofence-polygon-creator.component';
import { ZoneSelectorComponent } from './map-features/sections/geofences-section/components/4-panel-edit-geofences/molecules/zone-selector/zone-selector.component';
import { PanelEditGeofencesComponent } from './map-features/sections/geofences-section/components/4-panel-edit-geofences/organisms/panel-edit-geofences/panel-edit-geofences.component';
import { FilterMapAutocompleteComponent } from './map-features/sections/locations-section/components/2-panel-locations/molecules/filters/filter-map-autocomplete/filter-map-autocomplete.component';
import { SearchBarComponent } from './map-features/sections/locations-section/components/2-panel-locations/molecules/search-bar/search-bar.component';
import { FilteredCategoryTabComponent } from './map-features/sections/locations-section/components/2-panel-locations/molecules/ubicacion-category/filtered-category-tab.component';
import { FilterCategoriesComponent } from './map-features/sections/locations-section/components/2-panel-locations/organisms/filters/filters-categories/filter-categories.component';
import { FilterMapComponent } from './map-features/sections/locations-section/components/2-panel-locations/organisms/filters/filters-map/filter-map.component';
import { PanelLocationsComponent } from './map-features/sections/locations-section/components/2-panel-locations/organisms/panel-locations/panel-locations.component';
import { SkeletonLoaderComponent } from './map-features/sections/locations-section/components/3-panel-detail-locations/molecules/skeleton-loader/skeleton-loader.component';
import { CarDetailsComponent } from './map-features/sections/locations-section/components/3-panel-detail-locations/organisms/categories-details-panels/car-details/car-details.component';
import { EngineerDetailsComponent } from './map-features/sections/locations-section/components/3-panel-detail-locations/organisms/categories-details-panels/engineer-details/engineer-details.component';
import { GenericLocationDetailsComponent } from './map-features/sections/locations-section/components/3-panel-detail-locations/organisms/categories-details-panels/generic-location-details/generic-location-details.component';
import { GenericVirtualLocationDetailsComponent } from './map-features/sections/locations-section/components/3-panel-detail-locations/organisms/categories-details-panels/generic-virtual-location-details/generic-virtual-location-details.component';
import { ProspectLocationDetailsComponent } from './map-features/sections/locations-section/components/3-panel-detail-locations/organisms/categories-details-panels/prospect-location-details/prospect-location-details.component';
import { ServiceDetailsComponent } from './map-features/sections/locations-section/components/3-panel-detail-locations/organisms/categories-details-panels/service-details/service-details.component';
import { GeneralLocationsDetailsPopUpComponent } from './map-features/sections/locations-section/components/3-panel-detail-locations/organisms/location-popup-details/general-location-detail-popup/general-location-details-popup.component';
import { LocationsLocationDetailPopupComponent } from './map-features/sections/locations-section/components/3-panel-detail-locations/organisms/location-popup-details/locations-location-detail-popup/locations-location-detail-popup.component';
import { PlaceLocationDetailsPopUpComponent } from './map-features/sections/locations-section/components/3-panel-detail-locations/organisms/location-popup-details/place-location-detail-popup/place-location-details-popup.component';
import { ProspectDetailsPopupComponent } from './map-features/sections/locations-section/components/3-panel-detail-locations/organisms/location-popup-details/prospect-details-popup/prospect-details-popup.component';
import { ServiceLocationDetailPopupComponent } from './map-features/sections/locations-section/components/3-panel-detail-locations/organisms/location-popup-details/service-location-detail-popup/service-location-detail-popup.component';
import { LocationRelatedListComponent } from './map-features/sections/locations-section/components/3-panel-detail-locations/organisms/location-related/location-related-list/location-related-list.component';
import { LocationRelatedTicketPopupComponent } from './map-features/sections/locations-section/components/3-panel-detail-locations/organisms/location-related/location-related-ticket-popup/location-related-ticket-popup.component';
import { PanelDetailLocationsComponent } from './map-features/sections/locations-section/components/3-panel-detail-locations/organisms/main-details-panel/panel-detail-locations.component';
import { ValetParkingMapComponent } from './map-features/sections/locations-section/components/3-panel-detail-locations/organisms/valet-parking-map/valet-parking-map.component';
import { GeneratedLayersComponent } from './map-features/sections/locations-section/components/4-panel-layers/molecules/generated-layers/generated-layers.component';
import { LocationSearcherComponent } from './map-features/sections/locations-section/components/4-panel-layers/molecules/location-searcher/location-searcher.component';
import { PanelExternalLayersComponent } from './map-features/sections/locations-section/components/4-panel-layers/organisms/panel-external-layers/panel-external-layers.component';
import { PanelMapLayersComponent } from './map-features/sections/locations-section/components/4-panel-layers/organisms/panel-map-layers/panel-map-layers.component';
import { RecurrentPlacesClusterDetailsComponent } from './map-features/sections/locations-section/components/5-recurrent-places/molecules/recurrent-places-cluster-details/recurrent-places-cluster-details.component';
import { RecurrentPlacesComponent } from './map-features/sections/locations-section/components/5-recurrent-places/organisms/recurrent-places/recurrent-places.component';
import { DetailsIconsPipe } from './map-features/sections/locations-section/pipes/details-icons.pipe';
import { ValetParkingService } from './map-features/sections/locations-section/services/ValetParking.service';
import { ZoneLocationSearcherComponent } from './map-features/sections/potential-zones-section/components/molecules/zone-location-searcher/zone-location-searcher.component';
import { PotentialZonesMapComponent } from './map-features/sections/potential-zones-section/components/template/potential-zones-section/potential-zones-section.component';
import { ProspectsMapComponent } from './map-features/sections/prospects-section/components/template/prospects-section/prospects-section.component';
import { ProspectsPanelComponent } from './map-features/sections/prospects-section/components/organisms/prospects-panel/prospects-panel.component';
import { PopupDetailGeoposComponent } from './map-features/sections/route-section/components/3-panel-resume-route/molecules/popup-detail-geopos/popup-detail-geopos.component';
import { TerritoriesSectionComponent } from './map-features/sections/territories-section/components/1-territories-section/template/territories-section/territories-section.component';
import { TerritoriesFilterPopupComponent } from './map-features/sections/territories-section/components/2-territories-panel/molecules/territories-filter-popup/territories-filter-popup.component';
import { TerritoriesPanelComponent } from './map-features/sections/territories-section/components/2-territories-panel/organisms/territories-panel/territories-panel.component';
import { TerritoriesDetailsPanelComponent } from './map-features/sections/territories-section/components/3-territories-details-panel/organisms/territories-details-panel/territories-details-panel.component';
import { TerritoriesEditPanelComponent } from './map-features/sections/territories-section/components/4-territories-edit-panel/organisms/territories-edit-panel/territories-edit-panel.component';
import { RouteFrecuencyColorPipe } from './map-features/sections/territories-section/pipes/RouteFrecuencyColor.pipe';
import { RouteTypeColorPipe } from './map-features/sections/territories-section/pipes/RouteTypeColor.pipe';
import { RouteTypeIconPipe } from './map-features/sections/territories-section/pipes/RouteTypeIcon.pipe';
import { SaturationColorPipe } from './map-features/sections/territories-section/pipes/SaturationColor.pipe';
import { TerritoryAssignedColorPipe } from './map-features/sections/territories-section/pipes/TerritoryAssignedColor.pipe';
import { IsTerritorySelectedPipe } from './map-features/sections/territories-section/pipes/TerritoryIsSelected.pipe';
import { PopupReportHistorialComponent } from './map-features/ui/molecules/popup-report-historial/popup-report-historial.component';
import { GeocoderComponent } from './map-features/ui/organisms/geocoder/components/geocoder/geocoder.component';
import { AnnotationLayerGeneralManagementComponent } from './map-features/ui/organisms/layer-general-management/components/annotation-layer-general-management/annotation-layer-general-management.component';
import { AnnotationSearcherComponent } from './map-features/ui/organisms/layer-general-management/components/annotation-searcher/annotation-searcher.component';
import { LocationButtonToolbarComponent } from './map-features/ui/organisms/map-panel-button-toolbar/components/location-button-toolbar/location-button-toolbar.component';
import { PolygonSelectorWithLevelsComponent } from './map-features/ui/organisms/polygon-selector-with-levels/components/polygon-selector-with-levels/polygon-selector-with-levels.component';
import { PolygonSelectorComponent } from './map-features/ui/organisms/polygon-selector/components/polygon-selector/polygon-selector.component';
import { ScreenBlockerComponent } from './map-features/ui/organisms/screen-blocker/components/screen-blocker/screen-blocker.component';
import { ActionsComponent } from './pages/alarms/components/actions/actions.component';
import { ActiveAlarmsListComponent } from './pages/alarms/components/active-alarms-list/active-alarms-list.component';
import { ActiveAlarmsPopupComponent } from './pages/alarms/components/active-alarms-popup/active-alarms-popup.component';
import { AlarmTableComponent } from './pages/alarms/components/alarm-table/alarm-table.component';
import { SystemAlarmsListComponent } from './pages/alarms/components/system-alarms-list/system-alarms-list.component';
import { AlarmPageComponent } from './pages/alarms/page/locations-alarms/alarmPage.component';
import { SystemAlarmsPageComponent } from './pages/alarms/page/system-alarms/system-alarmsPage.component';
import { CallbackPageComponent } from './pages/callback/page/callbackPage.component';
import { SettingsMenuComponent } from './pages/dashboard-admin/components/settings-menu/settings-menu.component';
import { SettingsPageComponent } from './pages/dashboard-admin/settings-page/settings-page.component';
import { DownloadsListComponent } from './pages/download-center/components/downloads-list/downloads-list.component';
import { DownloadsTableComponent } from './pages/download-center/components/downloads-table/downloads-table.component';
import { DownloadsComponent } from './pages/download-center/page/downloads/downloads.component';
import { AlarmChartComponent } from './pages/main-dashboard/components/alarm-chart/alarm-chart.component';
import { AlertsCardComponent } from './pages/main-dashboard/components/alerts-card/alerts-card.component';
import { DashboardSidebarComponent } from './pages/main-dashboard/components/dashboard-sidebar/dashboard-sidebar.component';
import { LocationsCardComponent } from './pages/main-dashboard/components/locations-card/locations-card.component';
import { RequestsCardComponent } from './pages/main-dashboard/components/requests-card/requests-card.component';
import { UserCardComponent } from './pages/main-dashboard/components/user-card/user-card.component';
import { MainDashboardPageComponent } from './pages/main-dashboard/page/main-dashboard-page/main-dashboard-page.component';
import { MapToolsComponent } from './pages/maps/components/map-tools/map-tools.component';
import { ToolCarsSelectorComponent } from './pages/maps/components/tools/tool-cars-selector/tool-cars-selector.component';
import { ToolStreetInfoBoxComponent } from './pages/maps/components/tools/tool-street-info-box/tool-street-info-box.component';
import { EngineerMapComponent } from './pages/maps/page/engineer-map/engineer-map.component';
import { TicketMapComponent } from './pages/maps/page/ticket-map/ticket-map.component';
import { UnifiedMapComponent } from './pages/maps/page/unified-map/unified-map.component';
import { UnifiedZonesMapComponent } from './pages/maps/page/unified-zones-map/unified-zones-map.component';
import { NavNotificationsComponent } from './pages/notifications/components/nav-notifications/nav-notifications.component';
import { NotificationPageComponent } from './pages/notifications/page/notificationPage.component';
import { RolesAddComponent } from './pages/roles/components/roles-add/roles-add.component';
import { RolesListComponent } from './pages/roles/components/roles-list/roles-list.component';
import { RolesUpdateComponent } from './pages/roles/components/roles-update/roles-update.component';
import { RolePageComponent } from './pages/roles/page/rolePage.component';
import { TableauReportComponent } from './pages/tableau-dashboard/components/tableau-report/tableau-report.component';
import { DashboardPageComponent } from './pages/tableau-dashboard/page/dashboardPage.component';
import { CustomerControlComponent } from './pages/users/components/customer-control/customer-control.component';
import { UserLogsListComponent } from './pages/users/components/user-logs-list/user-logs-list.component';
import { UsersAddComponent } from './pages/users/components/users-add/users-add.component';
import { UserLogsPageComponent } from './pages/users/page/user-logsPage/user-logsPage.component';
import { FilterOptionsFromArray } from './shared/pipes/FilterOptionsFromArray.pipe';
import { FindUrlPipe } from './shared/pipes/FindUrlPipe.pipe';
import { NameToSingularPipe } from './shared/pipes/NameToSingular.pipe';
import { PermissionFilterPipe } from './shared/pipes/Permission-filter.pipe';
import { ReplaceIconPanel } from './shared/pipes/ReplaceIconPanel.pipe';
import { ImageCacheService } from './shared/services/ImageCache.service';
import { CarouselPopupComponent } from './ui/atoms/carousel-popup/carousel-popup.component';
import { CarouselComponent } from './ui/molecules/carousel/carousel.component';
import { SystemNotificationComponent } from './ui/molecules/system-notification/components/system-notification.component';
import { EiChatBotComponent } from './ui/organisms/azure-bot/components/ei-chat-bot/ei-chat-bot.component';
import { GenericTableComponent } from './ui/organisms/generic-table/components/generic-table.component';
import { LocationsTicketMapComponent } from './map-features/sections/locations-section/components/1-locations-section/template/locations-ticket-section/locations-ticket-section.component';
import { BusinessMapComponent } from './pages/maps/page/bussines-map/business-map.component';
import { PolygonSelectorWithLevelsControlTwoLevelsMapComponent } from './map-features/ui/organisms/polygon-selector-with-levels-control/components/polygon-selector-with-levels-control-two-levels/polygon-selector-with-levels-control-two-levels.component';
import { LocationsBusinessMapComponent } from './map-features/sections/locations-section/components/1-locations-section/template/locations-Business-section/locations-Business-section.component';
import { UnitsMapComponent } from './pages/maps/page/units-map/units-map.component';
import { RouteSheetGenericCardComponent } from './map-features/ui/Atoms/route-sheet-card/generic-card/generic-card.component';
import { RouteSheetDynamicCardComponent } from './map-features/ui/Atoms/route-sheet-card/dynamic-card/dynamic-card.component';
import { RouteSheetServicesCardComponent } from './map-features/ui/Atoms/route-sheet-card/services-card/services-card.component';
import { UnitCardComponent } from './map-features/ui/Atoms/route-sheet-card/unit-card/unit-card.component';
import { RouteSheetListComponent } from './map-features/ui/organisms/route-sheet/components/route-sheet-list/route-sheet-list.component';
import { RouteSheetComponent } from './map-features/ui/organisms/route-sheet/components/route-sheet/route-sheet.component';
import { PopupUpdateLocationComponent } from './map-features/ui/molecules/popup-update-location/popup-update-location.component';
import { PopupUpdateVirtualLocationComponent } from './map-features/ui/molecules/popup-update-virtual-location/popup-update-virtual-location.component';
import { PopupCreateLocationComponent } from './map-features/ui/molecules/popup-create-location/popup-create-location.component';
import { PopupCreateVirtualLocationComponent } from './map-features/ui/molecules/popup-create-virtual-location/popup-create-virtual-location.component';
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    MapComponent,
    PopupDetailGeoposComponent,
    PanelLocationsComponent,
    PanelInternalLayersComponent,
    PanelExternalLayersComponent,
    LoginPageComponent,
    ConfigurationsPageComponent,
    UserPageComponent,
    LoadingComponent,
    TooltipComponent,
    DashboardPageComponent,
    RouteMapComponent,
    RouteFilterComponent,
    LocationsMapComponent,
    BasemapSelectorComponent,
    PanelDetailLocationsComponent,
    PanelResumeRouteComponent,
    PanelDetailRouteStepsComponent,
    GeofencesMapComponent,
    PanelGeofencesComponent,
    TableauReportComponent,
    PanelDetailGeofencesComponent,
    PanelEditGeofencesComponent,
    NavHeaderComponent,
    FilterMapComponent,
    FilterMapAutocompleteComponent,
    ConfirmDialogComponent,
    ReportListComponent,
    MessageDialogComponent,
    UsersListComponent,
    GenericTableComponent,
    UsersAddComponent,
    UsersUpdateComponent,
    PopupReportHistorialComponent,
    RecoveryPasswordDialogComponent,
    RecoveryPasswordPageComponent,
    SendRecoveryPasswordDialogComponent,
    EmailSendDialogComponent,
    AdminVinControlComponent,
    CallbackPageComponent,
    ToolCarsSelectorComponent,
    AlarmPageComponent,
    RolePageComponent,
    RolesAddComponent,
    RolesUpdateComponent,
    PermissionFilterPipe,
    FindUrlPipe,
    FilterOptionsFromArray,
    UnifiedMapComponent,
    RecoveryPasswordDialogComponent, 
    MessageDialogComponent, 
    SendRecoveryPasswordDialogComponent, 
    EmailSendDialogComponent,
    CustomerControlComponent,
    UserLogsPageComponent,
    CarDetailsComponent,
    EngineerDetailsComponent,
    ServiceDetailsComponent,
    GenericLocationDetailsComponent,
    GenericVirtualLocationDetailsComponent,
    LocationRelatedListComponent,
    LocationRelatedTicketPopupComponent,
    ValetParkingMapComponent,
    SearchBarComponent,
    LocationButtonToolbarComponent,
    ActiveAlarmsListComponent,
    ActiveAlarmsPopupComponent,
    CarouselComponent,
    CarouselPopupComponent,
    SystemNotificationComponent,
    NotificationPageComponent,
    ActionsComponent,
    GeneralLocationsDetailsPopUpComponent,
    PlaceLocationDetailsPopUpComponent,
    PanelMapLayersComponent,
    EiChatBotComponent,
    SystemAlarmsPageComponent,
    RecurrentPlacesComponent,
    RecurrentPlacesClusterDetailsComponent,
    NavNotificationsComponent,
    RouteSheetComponent,
    RouteSheetListComponent,
    GeneratedLayersComponent,
    RouteSheetServicesCardComponent,
    RouteSheetGenericCardComponent,
    RouteSheetDynamicCardComponent,
    UnitCardComponent,
    ServiceLocationDetailPopupComponent,
    LocationsLocationDetailPopupComponent,
    NameToSingularPipe,
    ReplaceIconPanel,
    RolesListComponent,
    UserLogsListComponent,
    SystemAlarmsListComponent,
    SettingsPageComponent,
    SettingsMenuComponent,
    ToolStreetInfoBoxComponent,
    DownloadsComponent,
    DownloadsListComponent,
    DownloadsTableComponent,
    MainDashboardPageComponent,
    UserCardComponent,
    LocationsCardComponent,
    RequestsCardComponent,
    AlertsCardComponent,
    DashboardSidebarComponent,
    AlarmTableComponent,
    ZoneSelectorComponent,
    BufferSelectorComponent,
    GeofencePolygonCreatorComponent,
    AlarmChartComponent,
    ScreenBlockerComponent,
    SkeletonLoaderComponent,
    DetailsIconsPipe,
    FrecuencyIconsPipe,
    UnifiedZonesMapComponent,
    PotentialZonesMapComponent,
    ProspectsMapComponent,
    ProspectsPanelComponent,
    PolygonSelectorWithLevelsComponent,
    PolygonSelectorComponent,
    FrecuencyZonesSectionComponent,
    MapToolsComponent,
    GeocoderComponent,
    FilteredCategoryTabComponent,
    FilterCategoriesComponent,
    TerritoriesPanelComponent,
    TerritoriesDetailsPanelComponent,
    TerritoriesSectionComponent,
    TerritoriesFilterPopupComponent,
    RouteTypeColorPipe,
    RouteFrecuencyColorPipe,
    SaturationColorPipe,
    TerritoryAssignedColorPipe,
    RouteTypeIconPipe,
    ProspectLocationDetailsComponent,
    ProspectDetailsPopupComponent,
    AnnotationLayerGeneralManagementComponent,
    IsTerritorySelectedPipe,
    TerritoriesEditPanelComponent,
    ZoneLocationSearcherComponent,
    LocationSearcherComponent,
    AnnotationSearcherComponent,
    EngineerMapComponent,
    TicketMapComponent,
    ErrorPageComponent,
    LocationsTicketMapComponent,
    BusinessMapComponent,
    LocationsBusinessMapComponent,
    PolygonSelectorWithLevelsControlTwoLevelsMapComponent,
    UnitsMapComponent,
    PopupUpdateLocationComponent,
    PopupUpdateVirtualLocationComponent,
    PopupCreateLocationComponent,
    PopupCreateVirtualLocationComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: "ng-cli-universal" }),
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatExpansionModule,
    DragDropModule,
    ToastrModule.forRoot({
      timeOut: 2000,
    }),
    CommonModule,
   
    JwtModule,
    MaterialModule,
    FormsModule,
    BrowserModule,
    ReactiveFormsModule,
    HttpClientModule,
    ToastrModule,
    BrowserAnimationsModule,
    NgChartsModule,
    NgxSkeletonLoaderModule,
    MatChipsModule,
    ScrollingModule,
    // ApiAuthorizationModule,
    
    RouterModule.forRoot(
      [
        { path: "", redirectTo: "/home", pathMatch: "full" },
        { path: "home", component: HomeComponent },
        { path: "login", component: LoginPageComponent },
        { path: "logout", component: LogoutComponent },
        { path: "users", component: UserPageComponent, canActivate: [AuthGuard] },
        { path: "users/add", component: UsersAddComponent, canActivate: [AuthGuard] },
        { path: "users/update", component: UsersUpdateComponent, canActivate: [AuthGuard] },
        { path: "roles", component: RolePageComponent, canActivate: [AuthGuard] },
        { path: "roles/add", component: RolesAddComponent, canActivate: [AuthGuard] },
        { path: "roles/update", component: RolesUpdateComponent, canActivate: [AuthGuard] },
        { path: "roles", component: RolePageComponent, canActivate: [AuthGuard] },
        { path: "userLogs", component: UserLogsPageComponent, canActivate: [AuthGuard] },
        { path: "locationsMap", component: LocationsMapComponent, canActivate: [AuthGuard] },
        { path: "routingMap", component: RouteMapComponent, canActivate: [AuthGuard] },
        { path: "geofencesMap", component: GeofencesMapComponent, canActivate: [AuthGuard] },
        { path: "alarms", component: AlarmPageComponent, canActivate: [AuthGuard] },
        { path: "systemAlarms", component: SystemAlarmsPageComponent, canActivate: [AuthGuard] },
        { path: "notifications", component: NotificationPageComponent, canActivate: [AuthGuard] },
        { path: 'recoveryPassword/:key', component: RecoveryPasswordPageComponent},
        { path: "dashboardAdmin", component: ConfigurationsPageComponent, canActivate: [AuthGuard] },
        { path: "settingsAdmin", component: SettingsPageComponent, canActivate: [AuthGuard] },
        { path: "dashboard", component: DashboardPageComponent, canActivate: [AuthGuard] },
        { path: "callback", component: CallbackPageComponent },
        { path: "unifiedMap", component: UnifiedMapComponent, canActivate: [AuthGuard] },
        { path: "unifiedZonesMap", component: UnifiedZonesMapComponent, canActivate: [AuthGuard] },
        { path: "technicianMap", component: EngineerMapComponent, canActivate: [AuthGuard] },
        { path: "businessMap", component: BusinessMapComponent, canActivate: [AuthGuard] },
        { path: "ticketMap", component: TicketMapComponent, canActivate: [AuthGuard] },
        { path: "error", component: ErrorPageComponent },
        { path: "downloads", component: DownloadsComponent, canActivate: [AuthGuard] },
        { path: "mainDashboard", component: MainDashboardPageComponent, canActivate: [AuthGuard] },
        // { path: "**", component: PageNotFoundComponent },
        // { path: 'fetch-data', component: FetchDataComponent, canActivate: [AuthorizeGuard] },
      ],
      { useHash: true, onSameUrlNavigation: "reload" }
    ),
  ],
  exports: [],
  providers: [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
        logErrors: true,
      }),
    },
    {
      provide: MatPaginatorIntl,
      useClass: SpanishPaginatorIntl,
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SentryHttpInterceptorService,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [Sentry.TraceService, ImageCacheService],
      multi: true,
    },
    {
      provide: JWT_OPTIONS,
      useValue: JWT_OPTIONS,
    },
    JwtHelperService,
    SignalRService,
    MapHelperService,
    ValetParkingService,
    NameToSingularPipe,
    PermissionFilterPipe,
    ReplaceIconPanel,
    RouteTypeColorPipe,
    RouteFrecuencyColorPipe,
    SaturationColorPipe,
    TerritoryAssignedColorPipe,
    RouteTypeIconPipe,
    {provide: MAT_DATE_LOCALE, useValue: 'es-ES'} 
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

export function initializeApp(trace: Sentry.TraceService, imageCache: ImageCacheService) {
  return (): Promise<void> => {
    return imageCache.ensureInitialized();
  };
}